import { createSelector } from 'reselect';

const giotalkChatsSelector = state => state.giotalk.chats;
const giotalkChatIdSeleccionadoSelector = state => state.giotalk.chatSeleccionadoId;

export const chatSeleccionadoSelector = createSelector(
  [giotalkChatsSelector, giotalkChatIdSeleccionadoSelector],
  (chats, chatSeleccionadoId) => {
    const chatsFiltrados = chats.filter(chat => chat.id == chatSeleccionadoId);
    return chatsFiltrados.pop();
  },
);
